import React from "react";
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle
} from "@material-ui/core";
import { useEventContext } from "../../../state/events/context";
import { useAppContext } from "../../../state/app/context";

const GameDataConflictNotification = () => {
	const { state: appState } = useAppContext();
	const isSubmitting = appState.isSubmitting();

	const { state: eventState, overWriteEventData } = useEventContext();
	const remoteEventChanged = !!eventState.remoteEventChanged();

	return (
		<Dialog open={remoteEventChanged}>
			<DialogTitle>Game Data Conflict</DialogTitle>
			<DialogContent>
				<DialogContentText>
					Remote changes detected for current game, local changes must be
					overwritten.
				</DialogContentText>
				<DialogContentText />
			</DialogContent>
			<DialogActions>
				<Button
					disabled={isSubmitting}
					onClick={overWriteEventData}
					color="primary"
				>
					Continue
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default GameDataConflictNotification;
